// import create from "zustand";
import { create } from 'zustand';


const initialState = {
  showNavbar: true,
  showSeo: false,
  dropdown: "",
  shouldAnimate: false,
  CIN: "",
  prevItemName: null,
  isSubScribe: false,
  direction: sessionStorage.getItem("direction") || "ltr",
  Theme: sessionStorage.getItem("theme") || "default", 
};

const useStore = create((set) => ({
  ...initialState,
  setshowNavbar: (auth) =>
    set((state) => ({ ...state, showNavbar: !state.showNavbar })),
  setshowNSeo: (auth) =>
    set((state) => ({ ...state, showSeo: !state.showSeo })),
  setToken: (data) => set((state) => ({ ...state, Token: data })),
  setCIN: (data) => set((state) => ({ ...state, CIN: data })),
  setShouldAnimate: (data) =>
    set((state) => ({ ...state, shouldAnimate: data })),
  setIssubscribe: (data) =>
    set((state) => ({ ...state, isSubScribe: data })),
  toggleDirection: (data) => {
    sessionStorage.setItem("direction", data);
    set((state) => ({ ...state, direction: data }));
  },
  setTheme: (theme) => {
    sessionStorage.setItem("theme", theme); 
    set((state) => ({ ...state, Theme: theme })); 
  },
}));

export default useStore;
